import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7687fdea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "whole-charts" }
const _hoisted_2 = { class: "charts-container" }
const _hoisted_3 = { class: "chart-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Job Chart", -1))
const _hoisted_5 = { class: "chart-info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "chart-wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Task Chart", -1))
const _hoisted_11 = { class: "chart-info" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, onMounted, watch } from 'vue';
import { useChartStore } from '@/stores/PieChart';
import { Chart, registerables } from 'chart.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'PieChartComponent',
  setup(__props) {

Chart.register(...registerables);

const chartStore = useChartStore();
let jobsChart: Chart | null = null;
let tasksChart: Chart | null = null;

const jobsCanvasRef = ref<HTMLCanvasElement | null>(null);
const tasksCanvasRef = ref<HTMLCanvasElement | null>(null);

const createChart = (context: CanvasRenderingContext2D, chartData: number[]) => {
    return new Chart(context, {
        type: 'doughnut',
        data: {
            labels: ['Not Started', 'In Progress', 'Completed'],
            datasets: [{
                data: chartData,
                backgroundColor: ['#ff6f61', '#ffff99', '#61a2ff'],
            }],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
        },
    }) as Chart<"doughnut", number[], string>;
};

onMounted(() => {
    if (jobsCanvasRef.value && tasksCanvasRef.value) {
        const jobsContext = jobsCanvasRef.value.getContext('2d');
        const tasksContext = tasksCanvasRef.value.getContext('2d');

        if (jobsContext && tasksContext) {
            jobsChart = createChart(jobsContext, [0, 0, 0]) as Chart<"doughnut", number[], string>;
            tasksChart = createChart(tasksContext, [0, 0, 0]) as Chart<"doughnut", number[], string>;
        }
    }
    chartStore.fetchAndProcessJobsData();
    chartStore.fetchAndProcessTasksData();
});

watch(() => chartStore.jobsChartData, (newData) => {
    if (jobsChart) {
        jobsChart.data.datasets[0].data = [
            newData.notStarted,
            newData.inProgress,
            newData.completed
        ];
        jobsChart.update();
    }
}, { deep: true });

watch(() => chartStore.tasksChartData, (newData) => {
    if (tasksChart) {
        tasksChart.data.datasets[0].data = [
            newData.notStarted,
            newData.inProgress,
            newData.completed
        ];
        tasksChart.update();
    }
}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("canvas", {
          ref_key: "jobsCanvasRef",
          ref: jobsCanvasRef
        }, null, 512),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _createTextVNode("Total Jobs: " + _toDisplayString(_unref(chartStore).jobsChartData.notStarted + _unref(chartStore).jobsChartData.inProgress +
                        _unref(chartStore).jobsChartData.completed) + " ", 1),
            _hoisted_6,
            _createTextVNode(" Completed: " + _toDisplayString(_unref(chartStore).jobsChartData.completed) + " ", 1),
            _hoisted_7,
            _createTextVNode(" In Progress: " + _toDisplayString(_unref(chartStore).jobsChartData.inProgress) + " ", 1),
            _hoisted_8,
            _createTextVNode(" Not Started: " + _toDisplayString(_unref(chartStore).jobsChartData.notStarted), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("canvas", {
          ref_key: "tasksCanvasRef",
          ref: tasksCanvasRef
        }, null, 512),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, [
            _createTextVNode("Total Tasks: " + _toDisplayString(_unref(chartStore).tasksChartData.notStarted + _unref(chartStore).tasksChartData.inProgress +
                        _unref(chartStore).tasksChartData.completed) + " ", 1),
            _hoisted_12,
            _createTextVNode(" Completed: " + _toDisplayString(_unref(chartStore).tasksChartData.completed) + " ", 1),
            _hoisted_13,
            _createTextVNode(" In Progress: " + _toDisplayString(_unref(chartStore).tasksChartData.inProgress) + " ", 1),
            _hoisted_14,
            _createTextVNode(" Not Started: " + _toDisplayString(_unref(chartStore).tasksChartData.notStarted), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})